import styled from 'styled-components'
import { Spin as AntdSpin } from 'antd'

export const Container = styled.div`
  background-color: white;
  height: 27rem;
  margin: 1rem;
  position: relative;
  width: 32rem;
`

export const CharAndLoading = styled.div`
  height: 100%;
  width: 100%;
`

export const Spin = styled(AntdSpin)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  z-index: 1;
`

export const DashboardDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
